// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__K-cmw","Button--primary":"Button_Button--primary__58d6N"};